import { useEffect } from 'react'
import { useGame } from '../state/store'

/**
 * Global keyboard shortcuts:
 * - Space: tap (when not focused on input)
 * - Enter: focus word craft input
 */
export function useKeyboardShortcuts(wordInputRef?: React.RefObject<HTMLInputElement>) {
  const tap = useGame((s) => s.tap)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't trigger when typing in an input
      const target = e.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return

      switch (e.code) {
        case 'Space':
          e.preventDefault()
          tap()
          break
        case 'Enter':
          e.preventDefault()
          wordInputRef?.current?.focus()
          break
      }
    }

    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [tap, wordInputRef])
}
